import { FacebookFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";
import { Grey1 } from "styles/antTheme/Colors";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

export const BTIconFacebookLightFilled: FunctionComponent<IBTIconProps> = (baseProps) => {
    const [props] = useAntIcon(baseProps);

    return <FacebookFilled {...props} style={{ ...props.style, color: Grey1 }} />;
};
